import axios from "axios";
import "./baseApi";

const getTickets = () => axios.get("CRM/Tickets");
const getTicket = (r) => axios.get("CRM/Ticket/" + r);

// پاسخ سبک برای polling ۳۰ ثانیه‌ای: فقط شناسه/زمان/دیده‌نشده هر تیکت + جمع‌بندی.
const getTicketsPulse = () => axios.get("CRM/TicketsPulse");
const sendRequest = (r) => axios.post("CRM/Request/", r);

const sendTicketMessage = (r, onUploadProgress) =>
    axios.put("CRM/Ticket/", r, { onUploadProgress });

const sendTicket = (r, onUploadProgress) =>
    axios.post("CRM/Ticket/", r, { onUploadProgress });

// نظرسنجی رضایت پس از بسته‌شدن تیکت.
// نیازمند endpoint سمت سرور: POST CRM/Ticket/{ticketId}/Rate  { Score: 1..5, Comment?: string }
// اگر endpoint هنوز اضافه نشده باشد، کامپوننت TicketRating خطای 404 را مؤدبانه نشان می‌دهد.
const rateTicket = (ticketId, payload) =>
    axios.post("CRM/Ticket/" + ticketId + "/Rate", payload);

// وضعیت سهمیه‌ی یک سرویس. فقط وقتی پاسخ IsOver=true باشد به کاربر هشدار نشان داده می‌شود.
const getSupportUsage = (serviceId) =>
    axios.get("CRM/SupportUsage/" + encodeURIComponent(serviceId));

export default {
    getTickets,
    getTicket,
    getTicketsPulse,
    sendTicketMessage,
    sendTicket,
    sendRequest,
    rateTicket,
    getSupportUsage,
};
